import { render, staticRenderFns } from "./Contract_page.vue?vue&type=template&id=6153ec4c&scoped=true&"
import script from "./Contract_page.vue?vue&type=script&lang=js&"
export * from "./Contract_page.vue?vue&type=script&lang=js&"
import style0 from "./Contract_page.vue?vue&type=style&index=0&id=6153ec4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6153ec4c",
  null
  
)

export default component.exports